import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { Observable } from "rxjs";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { BeforeMatchAnswer } from "@app/core/match/domain/model/before-match-question";

@Injectable({
  providedIn: "root",
})
export class PlayerWS {
  constructor(private baseHandler: BaseHandler) {}

  execute(
    selected_code: number,
    match_code: string,
    answers: BeforeMatchAnswer[],
    token: string
  ): Observable<void> {
    const parameters = new HandlerBuilder()
      .setMethod(HttpMethod.post)
      .setUrl(ApiUrls.IDENTIFY_PLAYER_ENDPOINT())
      .setAuthorization(new TokenAuthorization(token))
      .setBody({
        selected_code: selected_code,
        match_code: match_code,
        answers: answers,
      })
      .build();
    return this.baseHandler.execute(parameters);
  }
}
